export const tenantKey = (companyId, ...parts) => ['tenant', companyId ?? 'none', ...parts];

export const listKeys = {
  byProject: (companyId, projectId) => tenantKey(companyId, 'lists', String(projectId ?? '')),
  detail: (companyId, listId) => tenantKey(companyId, 'list', String(listId ?? '')),
};

export const boardQueryKey = (companyId, type, id) =>
  tenantKey(companyId, 'board', String(type ?? ''), String(id ?? ''));

export const companyUserKey = companyId => tenantKey(companyId, 'company-users');

export const invalidateScoped = (queryClient, segment) =>
  queryClient.invalidateQueries({
    predicate: query => Array.isArray(query.queryKey) && query.queryKey.includes(segment),
  });
